var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteFollow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F26464"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 17.5717L16 24.9997M16 24.9997L8.5 17.5717C8.00531 17.0903 7.61565 16.5117 7.35555 15.8723C7.09546 15.2329 6.97057 14.5466 6.98874 13.8566C7.00692 13.1666 7.16777 12.4878 7.46116 11.863C7.75456 11.2382 8.17414 10.6809 8.69349 10.2263C9.21284 9.77159 9.82071 9.42938 10.4788 9.22117C11.1369 9.01296 11.831 8.94327 12.5174 9.01649C13.2037 9.08971 13.8675 9.30425 14.4669 9.64659C15.0663 9.98894 15.5883 10.4517 16 11.0057C16.4135 10.4557 16.9361 9.99701 17.5351 9.65829C18.1341 9.31958 18.7965 9.10814 19.4809 9.03721C20.1654 8.96628 20.8571 9.03739 21.5128 9.24608C22.1685 9.45477 22.774 9.79656 23.2916 10.2501C23.8091 10.7035 24.2274 11.259 24.5204 11.8816C24.8134 12.5042 24.9747 13.1806 24.9943 13.8684C25.0139 14.5562 24.8913 15.2407 24.6341 15.8789C24.377 16.5172 23.9909 17.0955 23.5 17.5777L16 24.9997Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFollow);
export default __webpack_public_path__ + "static/media/deleteFollow.e737d6a5ff14afa2887613a5e4fb0084.svg";
export { ForwardRef as ReactComponent };